import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AdminSideMenu } from "../admin/AdminMenu";
import API_URL from "../../api/API";
import { useAdminAuthContext } from "../admin/useAdminAuthContext";

export const AdminManageMasterWorkout = () => {
  const { admin } = useAdminAuthContext();
  const navigate = useNavigate(); // ← Add this line

  const [workouts, setWorkouts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  // =========================
  // Fetch Master Workouts
  // =========================
  const fetchMasterWorkouts = async () => {
    try {
      setIsLoading(true);
      setError("");
  
      const res = await fetch(API_URL.ADMIN_GET_ALL_WORKOUTS, {
        method: "GET",
        headers: { Authorization: `Bearer ${admin.token}` },
      });
  
      const data = await res.json();
      console.log("Master Workouts API Response:", data); // ✅ debug
  
      if (!res.ok || !data?.status) {
        throw new Error(data?.message || "Failed to fetch master workouts");
      }
  
      setWorkouts(data.workouts || []);
    } catch (err) {
      console.error("fetchMasterWorkouts error:", err);
      setError(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    if (!admin?.token) return;
    fetchMasterWorkouts();
  }, [admin?.token]);

  return (
    <div className="flex h-screen bg-zinc-100">
      {/* Side Menu */}
      <AdminSideMenu />

      {/* Main Content */}
      <div className="flex-1 p-6 pt-16 flex flex-col">
        {/* Header */}
        <div className="mb-5 flex items-start justify-between gap-3">
          <div>
            <h1 className="text-2xl font-bold text-zinc-900">Master Workouts</h1>
            <p className="mt-1 text-sm text-zinc-600">
              View all master workouts. Click "Build Workout" to create steps.
            </p>
          </div>
        </div>

        {/* Error */}
        {error && (
          <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        )}

        {/* Table */}
        <div className="flex-1 overflow-auto rounded-2xl border border-zinc-200 bg-white shadow-sm">
  <table className="w-full table-auto">
    <thead className="sticky top-0 bg-zinc-50 border-b border-zinc-200">
      <tr>
        <th className="px-4 py-3 text-left text-xs font-semibold text-zinc-600">Title / Description</th>
        <th className="px-4 py-3 text-left text-xs font-semibold text-zinc-600">Steps / Status</th>
        <th className="px-4 py-3 text-left text-xs font-semibold text-zinc-600 w-[120px]">Actions</th>
      </tr>
    </thead>

    <tbody>
      {isLoading ? (
        <tr>
          <td colSpan="3" className="py-8 text-center text-sm text-zinc-500">
            Loading master workouts...
          </td>
        </tr>
      ) : workouts.length === 0 ? (
        <tr>
          <td colSpan="3" className="py-8 text-center text-sm text-zinc-500">
            No master workouts found.
          </td>
        </tr>
      ) : (
        workouts.map((w) => (
          <tr
            key={w._id}
            className="border-b border-zinc-100 hover:bg-zinc-50 transition"
          >
            {/* Title / Description with status dot */}
            <td className="px-4 py-3 flex items-start gap-2">
              {/* Status Dot */}
            {/* Status Dot */}
<span
  className={`mt-2 h-2.5 w-2.5 rounded-full ${
    w.lastStepExists ? "bg-green-500" : "bg-yellow-500"
  }`}
/>
              {/* Title & Description */}
              <div className="flex flex-col gap-1">
                <span className="font-semibold text-zinc-900">{w.title}</span>
                <span className="text-xs text-zinc-500 line-clamp-2">{w.description || "No description"}</span>
              </div>
            </td>

            {/* Steps / Status */}
         {/* Steps / Status */}
<td className="px-4 py-3 w-[140px]">
  <div className="flex flex-col gap-1">
    <span className="text-xs font-medium text-zinc-700">Steps: {w.totalSteps || 0}</span>
    <span
      className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${
        w.lastStepExists
          ? "bg-green-100 text-green-800 border border-green-200"
          : "bg-yellow-100 text-yellow-800 border border-yellow-200"
      }`}
    >
      {w.lastStepExists ? "Complete" : "Ongoing"}
    </span>
  </div>
</td>

            {/* Actions */}
            <td className="px-4 py-3 w-[120px]">
              <button
                onClick={() => navigate(`/administrator/admin/workout/build/${w._id}`)}
                className="w-full rounded-lg bg-blue-600 px-3 py-1 text-xs font-semibold text-white hover:bg-blue-700 transition"
              >
                Build
              </button>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>
      </div>
    </div>
  );
};
